import { UtilService } from '../../../../core/services/util.service';
import { AuthService } from '../../services/auth-login.service';
import React, { useState } from 'react';
import { User } from '../../models/user.model';
import { useNavigate } from 'react-router-dom';
import { Input, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { jo } from '../../../../theme/css-vars';

const RecoveryPassword: React.FC = () => {
    const navigate = useNavigate();
    const [user, setUser] = useState<User>(new User());
    const [loading, setLoading] = useState(false);

    const HandleInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setUser(prevUser => ({
            ...prevUser,
            [name]: value
        }));
    };

    const Validate = (user: User, callback: () => void) => {
        if (user.username.length === 0) {
            UtilService.Alert('Important!', 'info', 'You must enter your username.');
            return;
        }
        callback();
    }

    const RequestRecovery = async () => {
        try {
            setLoading(true);
            await AuthService.RequestPasswordRecovery(user.username);
            UtilService.Alert(
                'Success',
                'success',
                'Check your email for password recovery instructions.'
            );
            navigate('/login');
        } catch (error) {
            console.error('Recovery error:', error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="flex min-h-screen flex-col justify-center px-6 py-12 lg:px-8">
            <div className="max-w-[320px] w-full m-auto bg-white p-8 rounded-lg shadow-[0_0_0_1px_rgba(0,0,0,0.1),0_4px_12px_rgba(0,0,0,0.15)]">
                <div className="space-y-8 sm:mx-auto w-full">
                    <a href="/#/login">
                        <img className="mx-auto h-14 w-auto" src={require("../../../../assets/logo.png")} alt="Logo" />
                    </a>
                    <h2 className="mt-4 text-center text-2xl font-bold tracking-tight text-gray-900">Recover your password</h2>
                    <h5 className="mt-2 text-center text-sm text-gray-600">Enter your username to receive password recovery instructions</h5>
                </div>

                <div className="mt-8 w-full space-y-8">
                    <Input
                        id="username"
                        name="username"
                        type="text"
                        placeholder="Username"
                        value={user.username}
                        onChange={HandleInput}
                        disabled={loading}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                Validate(user, RequestRecovery);
                            }
                        }}
                    />
                    <button
                        onClick={() => Validate(user, RequestRecovery)}
                        disabled={loading}
                        className="flex w-full justify-center rounded-md bg-blue-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {loading ? (
                            <Spin indicator={<LoadingOutlined style={{ fontSize: 16, color: jo.onPrimary }} spin />} />
                        ) : (
                            'Request Password Recovery'
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RecoveryPassword;